import PropTypes from 'prop-types';
import { BsClipboardCheck } from 'react-icons/bs';

import Select from '#globalComponents/Forms/Select';
import Textarea from '#globalComponents/Forms/Textarea';
import TextInput from '#globalComponents/Forms/TextInput';

const PREISNIVEAU_OPTIONS = [
	{ value: 'niedrig', label: 'Niedrig (< 500 EUR)' },
	{ value: 'mittel', label: 'Mittel (500 - 5.000 EUR)' },
	{ value: 'hoch', label: 'Hoch (> 5.000 EUR)' },
];

const AnalysisReviewStep = ({ values, onChange, isManual = false }) => {
	const analysis = values.websiteAnalysis ?? {};

	const handleChange = (field, value) => {
		onChange({
			websiteAnalysis: {
				...analysis,
				[field]: value,
			},
		});
	};

	return (
		<div className="space-y-5">
			<div className="flex items-start gap-3">
				<div className="h-10 w-10 rounded-control bg-primary-100 text-primary-700 flex items-center justify-center flex-shrink-0">
					<BsClipboardCheck className="w-5 h-5" />
				</div>
				<div>
					<h2 className="text-lg font-semibold text-text">
						{isManual ? 'Ihr Firmenprofil' : 'KI-Analyse prüfen'}
					</h2>
					<p className="text-sm text-bgBase-800">
						{isManual
							? 'Drei kurze Angaben genügen — daraus erstellen wir Ihre Vertriebsstrategie und suchen passende Leads.'
							: 'Wir haben Ihre Website analysiert. Prüfen und korrigieren Sie die Ergebnisse, bevor wir Ihre Vertriebsstrategie erstellen.'}
					</p>
				</div>
			</div>

			<div>
				<label className="block text-sm font-medium text-text mb-1">
					Branche <span className="text-warning-500">*</span>
				</label>
				<TextInput
					placeholder="z. B. Webdesign-Agentur, Maschinenbau, Steuerberatung"
					value={analysis.branche ?? ''}
					onChange={(e) => handleChange('branche', e.target.value)}
				/>
			</div>

			<div>
				<label className="block text-sm font-medium text-text mb-1">
					Angebot / Dienstleistung <span className="text-warning-500">*</span>
				</label>
				<Textarea
					rows={3}
					placeholder="Was bieten Sie an? z. B. Wir entwickeln Websites und Online-Shops für kleine Unternehmen."
					value={analysis.angebot ?? ''}
					onChange={(e) => handleChange('angebot', e.target.value)}
				/>
			</div>

			<div>
				<label className="block text-sm font-medium text-text mb-1">
					Zielgruppe <span className="text-warning-500">*</span>
				</label>
				<Textarea
					rows={3}
					placeholder="Wen möchten Sie erreichen? z. B. Handwerksbetriebe und Ärzte in NRW mit 5-50 Mitarbeitern."
					value={analysis.zielgruppe ?? ''}
					onChange={(e) => handleChange('zielgruppe', e.target.value)}
				/>
			</div>

			<div>
				<label className="block text-sm font-medium text-text mb-1">
					Preisniveau <span className="text-warning-500">*</span>
				</label>
				<Select
					value={analysis.preisniveau_indikator ?? 'mittel'}
					onChange={(e) => handleChange('preisniveau_indikator', e.target.value)}
				>
					{PREISNIVEAU_OPTIONS.map((opt) => (
						<option key={opt.value} value={opt.value}>
							{opt.label}
						</option>
					))}
				</Select>
			</div>

			<div>
				<label className="block text-sm font-medium text-text mb-1">USP / Alleinstellungsmerkmale</label>
				<Textarea
					rows={2}
					placeholder="Optional — Was macht das Unternehmen besonders?"
					value={analysis.usp ?? ''}
					onChange={(e) => handleChange('usp', e.target.value)}
				/>
			</div>

			<div>
				<label className="block text-sm font-medium text-text mb-1">Weitere Informationen</label>
				<Textarea
					rows={2}
					placeholder="Optional — z. B. regional gebunden, internationaler Vertrieb, B2C-Anteil"
					value={analysis.weitere_signale ?? ''}
					onChange={(e) => handleChange('weitere_signale', e.target.value)}
				/>
			</div>
		</div>
	);
};

AnalysisReviewStep.propTypes = {
	values: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	isManual: PropTypes.bool,
};

AnalysisReviewStep.isValid = (v) => {
	const a = v.websiteAnalysis;
	if (!a) return false;
	return Boolean(a.branche?.trim() && a.angebot?.trim() && a.zielgruppe?.trim() && a.preisniveau_indikator);
};

export default AnalysisReviewStep;
